module.exports = __webpack_public_path__ + "static/img/label-01.a416acf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/flash/label-01.png
// module id = 9u4J
// module chunks = 31